import {
  fixFeatureButton,
  customizeSearch,
  createCustomToggle,
  updateContentMargin,
} from '../js/helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  customizeSearch();
  createCustomToggle();
  updateContentMargin();
});
